/**
 * Sales Analytics Page
 * Standalone page for sales analytics and reporting
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import AnalyticsTab from './AnalyticsTab';

const SalesAnalyticsPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Sales Analytics
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Analyze sales performance and trends
        </Typography>
      </Box>
      <AnalyticsTab />
    </Container>
  );
};

export default SalesAnalyticsPage;
